import { Component, OnInit, Input } from '@angular/core';
import { RESUME_COVER } from '../../all-documents';
import { Doc } from '../../document';

@Component({
  selector: 'app-about-me',
  templateUrl: './about-me.component.html',
  styleUrls: ['./about-me.component.css']
})
export class AboutMeComponent {

  documents = RESUME_COVER;
  selectedDoc: Doc;

  constructor() {}

  onSelect(doc: Doc): void {
    this.selectedDoc = doc;
    this.selectedDoc.visibility = !this.selectedDoc.visibility;
  }
}
